import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { VisuallyHidden } from "@/components/ui/visually-hidden";
import { StripeEmbeddedCheckout } from "@/components/StripeEmbeddedCheckout";
import type { CreateCheckoutSessionInput } from "@/lib/payments.functions";

export function CheckoutDialog({
  open,
  onOpenChange,
  params,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  params: CreateCheckoutSessionInput | null;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl max-h-[90vh] overflow-y-auto p-0">
        <VisuallyHidden>
          <DialogTitle>Checkout</DialogTitle>
        </VisuallyHidden>
        {params && <StripeEmbeddedCheckout params={params} />}
      </DialogContent>
    </Dialog>
  );
}
